import { render } from "./GameDetails.vue?vue&type=template&id=71bdcd6e&scoped=true"
import script from "./GameDetails.vue?vue&type=script&lang=js"
export * from "./GameDetails.vue?vue&type=script&lang=js"

import "./GameDetails.vue?vue&type=style&index=0&id=71bdcd6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bdcd6e"]])

export default __exports__